import { useMutation, useQuery, useQueryClient } from '@tanstack/react-query';
import { fetch_groom_report, fetch_owner_groom_report, publish_groom_report, save_groom_report } from './api';
import type { UpsertGroomReportInput } from './types';

const report_key = (booking_id: string) => ['vendor-groom-report', booking_id] as const;
const owner_report_key = (booking_id: string) => ['owner-groom-report', booking_id] as const;

export function use_groom_report(booking_id: string, enabled = true) {
  return useQuery({
    queryKey: report_key(booking_id),
    queryFn: () => fetch_groom_report(booking_id),
    enabled: enabled && booking_id.length > 0,
  });
}

export function use_save_groom_report(booking_id: string) {
  const qc = useQueryClient();
  const invalidate = () => {
    qc.invalidateQueries({ queryKey: report_key(booking_id) });
    qc.invalidateQueries({ queryKey: ['vendor-bookings'] });
  };
  const save_m = useMutation({
    mutationFn: (input: UpsertGroomReportInput) => save_groom_report(booking_id, input),
    onSuccess: invalidate,
  });
  const publish_m = useMutation({
    mutationFn: () => publish_groom_report(booking_id),
    onSuccess: invalidate,
  });
  return { save_m, publish_m };
}

/** Owner-side view of a published groom report (before/after). */
export function use_owner_groom_report(booking_id: string, enabled = true) {
  return useQuery({
    queryKey: owner_report_key(booking_id),
    queryFn: () => fetch_owner_groom_report(booking_id),
    enabled: enabled && booking_id.length > 0,
  });
}
